import { FundraisingStatus } from '@blockpulse3/graphql/hooks';

/**
 * getFundraisingStep.
 * Return fundraising status as step number.
 *
 * @param {FundraisingStatus} status
 * @returns {number}
 */
export function getFundraisingStep(status: FundraisingStatus): number {
  switch (status) {
    case FundraisingStatus.CLOSED:
    case FundraisingStatus.FINALIZED:
      return 3;
    default:
      return 1;
  }
}
